import { clearIndexedDbPersistence, terminate } from "firebase/firestore";
import { isFirestorePermissionDeniedError } from "./firestoreAuthReady";
import { isFirestoreInternalAssertionError } from "./firestoreInternalAssertion";

export const AUTH_BOOTSTRAP_PERSISTENCE_RESET_SESSION_KEY =
  "llp_firestore_persistence_reset";

const getSessionStorage = () => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage || null;
};

export const isAuthBootstrapPersistenceResetCandidate = (error) =>
  isFirestorePermissionDeniedError(error) || isFirestoreInternalAssertionError(error);

export const hasAttemptedAuthBootstrapPersistenceReset = (
  storage = getSessionStorage()
) => {
  try {
    return storage?.getItem(AUTH_BOOTSTRAP_PERSISTENCE_RESET_SESSION_KEY) === "true";
  } catch {
    return false;
  }
};

export const markAuthBootstrapPersistenceResetAttempted = (
  storage = getSessionStorage()
) => {
  try {
    storage?.setItem(AUTH_BOOTSTRAP_PERSISTENCE_RESET_SESSION_KEY, "true");
  } catch {
    // If sessionStorage is unavailable, still attempt the reset in this tab.
  }
};

export const clearAuthBootstrapPersistenceResetAttempted = (
  storage = getSessionStorage()
) => {
  try {
    storage?.removeItem(AUTH_BOOTSTRAP_PERSISTENCE_RESET_SESSION_KEY);
  } catch {
    // no-op
  }
};

export const shouldAttemptAuthBootstrapPersistenceReset = (
  error,
  storage = getSessionStorage()
) =>
  isAuthBootstrapPersistenceResetCandidate(error)
  && !hasAttemptedAuthBootstrapPersistenceReset(storage);

export async function resetFirestorePersistenceForAuthBootstrap(
  firestoreDb,
  {
    storage = getSessionStorage(),
    terminateFirestore = terminate,
    clearPersistence = clearIndexedDbPersistence,
    reload = () => window.location.reload(),
  } = {}
) {
  const result = {
    attempted: true,
    terminateSucceeded: false,
    clearSucceeded: false,
    reloadStarted: false,
    terminateError: null,
    clearError: null,
    reloadError: null,
  };

  markAuthBootstrapPersistenceResetAttempted(storage);

  try {
    await terminateFirestore(firestoreDb);
    result.terminateSucceeded = true;
  } catch (error) {
    result.terminateError = error;
  }

  try {
    await clearPersistence(firestoreDb);
    result.clearSucceeded = true;
  } catch (error) {
    result.clearError = error;
  }

  try {
    reload();
    result.reloadStarted = true;
  } catch (error) {
    result.reloadError = error;
  }

  return result;
}
